// Central config for brand, contacts, brochure, pricing, products, testimonials.
// Brochure served through backend proxy so it forces DOWNLOAD (Content-Disposition: attachment)
// instead of opening inline in a new tab. This works cross-browser on desktop and mobile.
const _BACKEND = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL) || '';

export const SITE = {
  brand: "Clamignon",
  tagline: "Beauty Technology by AEGENBIO",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_clami-fillers-chile/artifacts/ltt6f9q2_Untitled%20design%20%2814%29.webp",
  brochureUrl: `${_BACKEND}/api/brochure`,
  whatsapp: {
    number: "56929444421",
    display: "+56 9 2944 4421",
    message:
      "Hola, quiero evaluar el Programa Distribución Clamignon (100+ unidades/mes).",
  },
  email: "ventas@clamignon.cl",
  city: "Santiago, Chile",
};

export const NAV_LINKS = [
  { id: "cambiar", label: "Por qué cambiar" },
  { id: "portafolio", label: "Portafolio" },
  { id: "ahorro", label: "Ahorro" },
  { id: "precios", label: "Programa" },
];

export const PRICING = [
  {
    tier: "Starter",
    units: "100",
    price: "20.900",
    highlight: false,
    note: "Acceso al programa · condiciones mayoristas",
  },
  {
    tier: "Growth",
    units: "200",
    price: "19.900",
    highlight: false,
    note: "Clínicas escalando volumen mensual",
  },
  {
    tier: "Pro",
    units: "300",
    price: "16.900",
    highlight: true,
    note: "El tramo más elegido por clínicas premium",
  },
  {
    tier: "Elite",
    units: "500+",
    price: "14.900",
    highlight: false,
    note: "Precio de fábrica · máxima rentabilidad clínica",
  },
];

export const PRODUCTS = [
  {
    code: "201",
    name: "Clamignon 201",
    role: "Dermis superficial · Fine lines",
    ha: "24 mg/mL",
    gprime: "295 Pa",
    needle: "30G",
    duration: "6 – 9 meses",
    use: "HA monofásico de baja elasticidad para rítides periorbitales, líneas peribucales y bioestimulación dérmica superficial.",
    depth: "Dermis media / superficial",
  },
  {
    code: "202",
    name: "Clamignon 202",
    role: "Dermis profunda · Versátil",
    ha: "24 mg/mL",
    gprime: "301 Pa",
    needle: "27G",
    duration: "9 – 12 meses",
    use: "HA cross-linked de elasticidad media para surcos nasogenianos, aumento y remodelación de labios, y pliegues moderados.",
    depth: "Dermis profunda",
  },
  {
    code: "203",
    name: "Clamignon 203",
    role: "Subcutáneo · Volumen estructural",
    ha: "24 mg/mL",
    gprime: "275 Pa",
    needle: "25G",
    duration: "12 – 18 meses",
    use: "HA de alta cohesividad y proyección para volumen malar, definición mandibular, mentón, rinomodelación y contorno facial.",
    depth: "Subcutáneo profundo",
  },
];

export const MARKET_COMPARISON = [
  { label: "Marca premium europea", sub: "Referencia de mercado", price: 76900, display: "$76.900", tone: "muted" },
  { label: "Marca coreana media", sub: "Distribución tradicional", price: 42900, display: "$42.900", tone: "muted" },
  { label: "Clamignon · 100 u/mes", sub: "Entrada al programa", price: 20900, display: "$20.900", tone: "brand" },
  { label: "Clamignon · 500+ u/mes", sub: "Precio de fábrica", price: 14900, display: "$14.900", tone: "brand-hot" },
];

export const QUANTITY_OPTIONS = [
  "100 – 199 unidades / mes",
  "200 – 299 unidades / mes",
  "300 – 499 unidades / mes",
  "500+ unidades / mes",
];

export const STEPS = [
  { n: "01", text: "Solicita tu evaluación de precio confidencial." },
  { n: "02", text: "Recibe stock, factura y certificado ISP por lote." },
  { n: "03", text: "Rentabiliza cada procedimiento de tu clínica." },
];

// "4 razones por las que las clínicas top cambian a Clamignon"
export const BENEFITS = [
  {
    title: "El mismo grado clínico. Sin el markup del intermediario.",
    body:
      "Compras directo a fábrica AEGENBIO (Korea, KGMP · ISO 13485). Sin subdistribuidor local que agregue 40–60% al precio. Mismo HA 24 mg/mL cross-linked BDDE que ya conoces — a precio de importador.",
  },
  {
    title: "Stock permanente en Santiago. Sin quiebres de inventario.",
    body:
      "Contenedores completos importados cada trimestre. Bodega en Santiago con inventario de seguridad para las tres líneas 201·202·203. No vuelves a llamar a un proveedor que 'te avisa cuando llegue'.",
  },
  {
    title: "Certificado ISP por cada lote. Trazabilidad completa.",
    body:
      "Solicítalo con cada compra. Registro sanitario Chile como Dispositivo Médico. Respaldo clínico, legal y de imagen frente a tu paciente — sin excusas del proveedor.",
  },
  {
    title: "Precio por volumen comprometido. No por 'oferta del mes'.",
    body:
      "Tu tramo de precio queda escriturado según tu consumo mensual. Sin negociar cada compra. Sin cambios sorpresa. Sin promesas verbales. Todo con factura tributaria y ejecutivo dedicado.",
  },
];

// Pain / desire dual list for the switch narrative
export const SWITCH_LIST = {
  painTitle: "Tu proveedor actual:",
  pain: [
    "Te vende con markup de 40% a 80% sobre precio de fábrica.",
    "Cada compra es una negociación distinta.",
    "Se queda sin stock justo cuando tu agenda está llena.",
    "No entrega certificado ISP por lote a menos que insistas.",
    "Trata igual a la clínica de 50 unidades que a la de 500.",
    "Cambia el precio 'por tipo de cambio' cuando le conviene.",
  ],
  gainTitle: "Programa Distribución Clamignon:",
  gain: [
    "Directo de fábrica Korea.",
    "Tramo de precio fijo según tu volumen mensual escriturado.",
    "Stock permanente en Santiago. Reposición trimestral.",
    "Certificado ISP y factura tributaria en cada compra.",
    "Programa por invitación · solo clínicas ≥ 100 u/mes.",
    "Ejecutivo dedicado. Sin call center. Sin excusas.",
  ],
};

// Savings calculator scenarios (used in SavingsCalculator component)
export const SAVINGS_SCENARIOS = [
  {
    volume: "100 u/mes",
    volumeNum: 100,
    market: 42900,
    clamignon: 20900,
    label: "Clínica particular",
  },
  {
    volume: "250 u/mes",
    volumeNum: 250,
    market: 42900,
    clamignon: 19900,
    label: "Cadena boutique",
  },
  {
    volume: "500 u/mes",
    volumeNum: 500,
    market: 42900,
    clamignon: 14900,
    label: "Cadena de alto flujo",
    highlight: true,
  },
];

export const TESTIMONIALS = [
  {
    tag: "Cambió de marca premium europea",
    quote:
      "Veníamos usando una marca europea a $58.000 la jeringa. Cambiamos a Clamignon manteniendo grado clínico y resultado. Recuperamos margen de un semestre completo en 3 meses.",
    name: "Dra. Camila Fuentes",
    role: "Directora médica · Providencia",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    metric: "Recuperó un semestre de margen en 90 días",
  },
  {
    tag: "Cambió de distribuidor coreano local",
    quote:
      "Nuestro problema no era el precio. Era el stock. Con Clamignon dejamos de perder pacientes por 'llega en dos semanas'. Reponemos automáticamente cada trimestre.",
    name: "Dr. Rodrigo Andrade",
    role: "Head of Injectables · 4 sucursales",
    avatar:
      "https://images.unsplash.com/photo-1622253692010-333f2da6031d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    metric: "Cero quiebres de stock en 12 meses",
    highlight: true,
  },
  {
    tag: "Migró desde 3 proveedores distintos",
    quote:
      "Teníamos tres proveedores para cubrir 201·202·203. Con Clamignon todo pasó a un solo ejecutivo, un solo pedido, una sola factura al mes. Menos administración, mejor precio.",
    name: "Dra. Valentina Soto",
    role: "Estética facial · Vitacura",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    metric: "3 proveedores → 1 ejecutivo dedicado",
  },
];
